import domain from './domain';

// List of AI images
export const resetAiImages = domain.createEvent('resetAiImages');
